const {obj_valExist_fb} = require( "./Share_S_Obj");
const {enum_langCodes, enum_typeof} = require( "./Share_S_Enum");

// ========= validator basic ============

// validator_null_fb
export const validator_null_fb = (val ) => {
    return val == null
}

// validator_boolean_fb
export const validator_boolean_fb = (value) => {
    return typeof value === 'boolean'
}

// validator_string
export const validator_string_fb = (value ) => {
    return typeof value === 'string'
}

// validator_enum
export const validator_enum_fb = (enum_byEnumName , value ) =>{
    return obj_valExist_fb(enum_byEnumName, value)
}

// validator_number_fb
export const validator_number_fb = (value ) => {
    return typeof value === 'number' && !isNaN(value)
}

// validator_arrayObj_fb
export const validator_arrayObj_fb = (obj_o) => {

    let arrayObj_b = true
    for(let key in obj_o){

        arrayObj_b = arrayObj_b && !isNaN(parseInt(key))

        if(!arrayObj_b){
            break;
        }
    }
    return arrayObj_b
}

// validator_number_fb
export const validator_number_double_fb = (value ) => {
    return validator_number_fb(value) && value % 1 != 0
}

// validator_typeOf_fb
export const validator_typeOf_fb = (variable , typeof_e ) => {
    if(typeof variable !== typeof_e){
        return false
    }
    return true
}

// validator_array_fb
export const validator_array_fb = (arr) => {
    return Array.isArray(arr)
}

// validator_obj_fb
export const validator_obj_fb = (obj ) => {

    if(obj == null || !(typeof obj === 'object')){
        return false
    }

    return true
}

// validator_class_fb
export const validator_class_fb = (val, classType) => {

    return val instanceof classType
}

// validator_function_fb
export const validator_function_fb = (value) => {
    return typeof value === 'function'
}

// ========= validator array ============

// validator_enum_array_fb
export const validator_enum_array_fb = (enumsValues_byEnumName, array) =>{

    if(!validator_array_fb(array)){
        return false
    }

    for(let i=0; i < array.length; i++){
        if(obj_valExist_fb(enumsValues_byEnumName, array[i]) == null)
            return false
    }

    return true
}

// validator_arrayClass_fb
export const validator_arrayClass_fb = (arr, classType) => {

    if(!validator_array_fb(arr)){
        return false
    }

    let ans = true;
    arr.forEach((item) => {
        ans = ans && validator_class_fb(item, classType)
    });

    return ans
}

// validator_arrayEnum_fb
export const validator_arrayEnum_fb = (arr, enum_byEnumName) => {

    if(!validator_array_fb(arr)){
        return false
    }

    let ans = true;
    arr.forEach((item) => {
        ans = ans && validator_enum_fb(enum_byEnumName, item)
    });

    return ans
}

// validator_array_typeOf_fb
export const validator_array_typeOf_fb = (arr, typeof_e) => {
    if(!validator_array_fb(arr)){
        return false
    }

    let ans = true
    arr.forEach((item)  => {
        ans = ans && validator_typeOf_fb(item, typeof_e)
    })

    return ans
}

// ========= validator object ============

// validator_objTypeof_fb
export const validator_objTypeof_fb = (obj, typeof_e) =>{
    if(!validator_obj_fb(obj))
        return false

    for(let key in obj){
        if(!validator_typeOf_fb(obj[key], typeof_e)){
            return false
        }
    }

    return true
}

// validator_objValStr_fb
export const validator_objValStr_fb = (obj) =>{
    if(!validator_obj_fb(obj))
        return false

    for(let key in obj){
        if(typeof obj[key] !== enum_typeof.string){
            return false
        }
    }

    return true
}

// validator_objValNumber_fb
export const validator_objValNumber_fb = (obj) =>{
    if(!validator_obj_fb(obj))
        return false

    for(let key in obj){
        if(typeof obj[key] !== enum_typeof.number){
            return false
        }
    }

    return true
}

// validator_ArrayClass
export const validator_objClass_fb = (obj, classType) => {

    if(!validator_obj_fb(obj)){
        return false
    }

    let ans = true;
    for(let key in obj){
        ans = ans && validator_class_fb(obj[key], classType)
    }

    return ans
}

// validator_enumKeys_fb
export const validator_onjKeysByEnumVal_fb = (obj, keyOptions_byKey) => {

    let ans_b = true
    for (let key_s in obj) {
        ans_b = ans_b && obj_valExist_fb(keyOptions_byKey, key_s)
    }

    return ans_b
}

// validator_objKeys_fb
export const validator_objKeys_fb = (obj_o , optionalKeys_o ) => {

    for(let key in obj_o){
        let objKey_s = obj_o[key]
        if(Object.values(optionalKeys_o).indexOf(objKey_s) > -1){
            return false
        }
    }

    return true

}

// validator_onjValuesByEnumVal_fb
export const validator_onjValuesByEnumVal_fb = (obj, keyOptions_byKey) => {

    let ans_b = true
    for (let key_s in obj) {
        ans_b = ans_b && obj_valExist_fb(keyOptions_byKey, obj[key_s])
    }

    return ans_b
}

// validator_objEmpty_fb
export const validator_objEmpty_fb = (obj) => {
    if (obj == null)
        return true

    return Object.keys(obj).length === 0 && obj.constructor === Object
}

// ========= validator custom ============

// validator_textByLangCode_fb
export const validator_textByLangCode_fb = (obj ) =>{

    if(validator_obj_fb(obj) === false){
        return false
    }

    let langCodes = Object.values(enum_langCodes)
    for(let key in obj){

        if(langCodes.includes(key) === false)
            return false
    }

    return true
}


// validator_timestamp_fb
export const validator_timestamp_fb = (timestamp_t) => {

    return validator_number_fb(timestamp_t)
        && (new Date(timestamp_t)).getTime() > 0

}

// validator_positiveNumber_fb
export const validator_positiveNumber_fb = (val ) => {

    return typeof val === 'number' && val > 0
}

// validator_typeOfVal_fb
export const validator_typeOfVal_fb = (obj, typeofObj) => {

    if (validator_obj_fb(obj) === false) {
        return false
    }

    return validator_typeOf_fb(obj.val, typeofObj)
}

// validator_pointerTypeOf_fb
export const validator_pointerTypeOf_fb = (p, type) => {

    return Object.keys(p).includes('val') &&
        (p.val == null || typeof p.val === type);
}


